export default function MeetupMenu({ color = "currentColor" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 8C18.7956 8 19.5587 8.31607 20.1213 8.87868C20.6839 9.44129 21 10.2044 21 11C21 11.7956 20.6839 12.5587 20.1213 13.1213C19.5587 13.6839 18.7956 14 18 14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8V19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.0019L16.524 4.2319C16.6555 4.12241 16.8154 4.05265 16.9851 4.03081C17.1548 4.00896 17.3271 4.03593 17.482 4.10855C17.6369 4.18117 17.7679 4.29644 17.8597 4.44085C17.9514 4.58526 18.0001 4.75282 18 4.9239V17.0799C18.0001 17.251 17.9514 17.4185 17.8597 17.563C17.7679 17.7074 17.6369 17.8226 17.482 17.8953C17.3271 17.9679 17.1548 17.9948 16.9851 17.973C16.8154 17.9511 16.6555 17.8814 16.524 17.7719L12 14.0019H4C3.73478 14.0019 3.48043 13.8965 3.29289 13.709C3.10536 13.5215 3 13.2671 3 13.0019V9.0019C3 8.73668 3.10536 8.48233 3.29289 8.29479C3.48043 8.10726 3.73478 8.0019 4 8.0019H12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
